const cognoblaze_24 =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/it/it_symbo_pic.webp";
const dpm =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Default_profile+/boy.webp";
const dpf =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Default_profile+/girl.webp";
const cover =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Cover/it_banner.webp";
const vinayagamoorthy = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/it/Faculties/vinayagamoorthy.webp";

const it_com_lab =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Lab_Facilities/it_com_lab.webp";
const it_case_lab =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Lab_Facilities/it_case_lab.webp";
const it_grap_lab =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Lab_Facilities/it_grap_lab.webp";
const it_dbms_lab =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Lab_Facilities/it_dbms_lab.webp";
const it_mpmc_lab =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Lab_Facilities/it_mpmc_lab.webp";

const uma_rani_sq =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/umarani_square.webp";

const uma_rani =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/it/Faculties/Teaching_fac/umarani.webp";
const suhaila =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Teaching_fac/suhaila.webp";
const sk =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Teaching_fac/sk.webp";
const hema =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Teaching_fac/hema.webp";
const anbu =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Teaching_fac/anbuselvi.webp";
const karthiga =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Teaching_fac/karthiga.webp";
const rajanandhini =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Teaching_fac/rajanandini.webp";
const ramakrishnan =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Teaching_fac/it_Ramakrishnan.webp";
const kalaiselvi =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Teaching_fac/it_Kalaiselvi.webp";
const vijay =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Supporting_fac/Vijay+Profile+2023.webp";
const chandraprabha =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Teaching_fac/chandraprabha.webp";
const raja =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Supporting_fac/raja.webp";
const rajendran =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Supporting_fac/rajendran.webp";
const akbar = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Faculties/Supporting_fac/akbarali+.webp";

const cogno =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Department_event/cognoblaze.webp";
const deftra =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Department_event/deftra.webp";
const deftra23 =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Department_event/Deftra23.webp";
const deftra25 =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Department_event/Deftra25.webp";
const codequest =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/it/Department_event/codequest.webp";

const projecthon =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/it/projecthon.webp";
const suryamam = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/it/Faculties/suryamam.webp";
const it_dept_menu = [
    {
        id: "1",
        path: "/itdept",
        link: "About the Department",
        arl: "l",
    },
    {
        id: "3",
        path: "/itdept/it-peo",
        link: "Programme Objectives & Outcomes",
        arl: "l",
    },
    {
        id: "5",
        path: "/itdept/it-faculties",
        link: "Faculty",
        arl: "l",
    },
    {
        id: "7",
        path: "/itdept/it-lab",
        link: "Laboratory Facilities",
        arl: "l",
    },
    {
        id: "10",
        path: "/itdept/it-dept-events",
        link: "Department Events",
        arl: "l",
    },
    {
        id: "12",
        path: "/itdept/it-prog",
        link: "Programme Organized",
        arl: "l",
    },

    // {
    //   id: "8",
    //   path: "#",
    //   link: "Professional Socities",
    //   arl:'l'
    // },
    // {
    //   id: "9",
    //   path: "#",
    //   link: "Research and Publications",
    //   arl:'l'
    // },

    {
        id: "13",
        path: "/itdept/it-mou",
        link: "MOU",
        arl: "l",
    },
    // {
    //   id: "14",
    //   path: "/itdept/Live-projects",
    //   link: "Live projects",
    //   arl: "l",
    // },
    {
        id: "15",
        path: "/itdept/Codequest",
        link: "Code-Quest",
        arl: 'l'
    },
    {
        id: "16",
        path: "/itdept/projecthon",
        link: "Projecthon",
        arl: 'l'
    },
];
const LiveProjects = [
    {
        projectTitle: "College Website",
        projectDesc:
            "Our college website (accet.ac.in) is proudly managed by a passionate team of it students. From updating academic content to publishing event highlights, the team ensures the site remains accurate, informative, and engaging. They are responsible for both the design and functionality, bringing innovation and reliability together. Under the guidance of faculty, the team continuously improves the digital presence of our institution.",
        staffName: "K.Chandraprabha",
        staffDesi: "Associate professor  / Department of it",
        // students: {
        //   fourthYear: [
        //     { name: "Arjun Prakash AS", linkedin: "https://www.linkedin.com/in/arjun-prakash-sivakumar-ab1872240" },
        //     { name: "Arockiya Belcy VS", linkedin: "http://www.linkedin.com/in/arockiya-belcy-vs" },
        //     { name: "Harish I", linkedin: "https://www.linkedin.com/in/harish-i-216000247/" },
        //     { name: "Kaviya B", linkedin: "https://www.linkedin.com/in/kaviya-b-6270b9247" },
        //     { name: "Sathiyan R", linkedin: "https://www.linkedin.com/in/sathiyan-r/" },
        //   ],
        //   thirdYear: [
        //     { name: "Gopinath S", linkedin: "https://www.linkedin.com/in/gopinath-s-250a2126a" },
        //     { name: "Kanishka M", linkedin: "https://www.linkedin.com/in/kanishka-m-5655472a0" },
        //     { name: "Mohanamala J", linkedin: "https://www.linkedin.com/in/mohana-mala-025a88245" },
        //     { name: "Sriram K", linkedin: "https://www.linkedin.com/in/sri-ram-1459192a2" },
        //   ],
        //   secondYear: [
        //     { name: "Alakeshvar Kumar R", linkedin: "https://www.linkedin.com/in/alakeshvarkumar" },
        //     { name: "Madasamy I", linkedin: "https://www.linkedin.com/in/madasamyi" },
        //     { name: "Pavitha M", linkedin: "https://www.linkedin.com/in/pavitha-m-b821b8289" },
        //     { name: "Visali E", linkedin: "https://www.linkedin.com/in/visali-elangovan-563608294" },
        //   ],
        // },
    },
    // {
    //   projectTitle: "Lateral Entry Admission",
    //   projectDesc: "Our it students play a vital role in maintaining the official Tamil Nadu Lateral Entry Admissions (TNLEA) government website. This platform handles thousands of student applications every year across the state. The team ensures seamless functionality, timely updates, and secure data management under the supervision of faculty experts.",
    //   staffName: "Dr. C. Umarani",
    //   staffDesi: "Head / Department of it",
    //   students: {
    //     fourthYear: [
    //       { name: "Harish I", linkedin: "https://www.linkedin.com/in/harish-i-216000247/" },
    //       { name: "Padmanathan M", linkedin: "https://www.linkedin.com/in/padmanaban8803" },
    //       { name: "Srivenkatachalapathy M", linkedin: "https://www.linkedin.com/in/srivenkatachalapathym" },
    //       { name: "Thilagarasan B", linkedin: "https://www.linkedin.com/in/thilagarasan-b-88aa14246" },
    //     ],
    //     thirdYear: [
    //       { name: "Amudhan M", linkedin: "https://www.linkedin.com/in/amudhan-m-0355762a5" },
    //       { name: "Chubathran K", linkedin: "https://www.linkedin.com/in/chubathran-k-0a03992a6" },
    //       { name: "Guru srinivasan P", linkedin: "https://www.linkedin.com/in/guru-srinivasan-73a39a2a6" },
    //       { name: "Monishwaran S", linkedin: "https://www.linkedin.com/in/monishwaran-s-7783992a6" },
    //     ],
    //     secondYear: [
    //       { name: "Hasan Hasim V M", linkedin: "https://www.linkedin.com/in/hasan-hasim-aa544126a" },
    //       { name: "Ranjith D", linkedin: "https://www.linkedin.com/in/ranjith-d-b824a6290" },
    //       { name: "Thamarai nagasamy K", linkedin: "https://www.linkedin.com/in/thamarai-nagasamy-0786672a5" },
    //       { name: "Vishnu R", linkedin: "https://www.linkedin.com/in/vishnu-undefined-3a7b52322" },
    //     ],
    //   },
    // },
    // {
    //   projectTitle: "ERP Website",
    //   projectDesc: "The ERP portal used within our college is fully developed and maintained by a skilled team of it students. This software streamlines various administrative tasks such as library management, student records, issue tracking, and more. The team ensures continuous updates, feature improvements, and technical support. Their work demonstrates how student-driven solutions can enhance institutional efficiency.",
    //   staffName: "Dr. C. Umarani",
    //   staffDesi: "Head / Department of it",
    //   students: {
    //     thirdYear: [
    //       { name: "Abinaya M", linkedin: "https://www.linkedin.com/in/abinaya-m-7a9a2126a" },
    //       { name: "Abinesh S A", linkedin: "https://www.linkedin.com/in/abineshsa/" },
    //       { name: "Dhanush A", linkedin: "https://www.linkedin.com/in/dhanush-a-1b8a1226a" },
    //       { name: "Kaviya S", linkedin: "http://www.linkedin.com/in/kaviya-s-0046552a5" },
    //       { name: "Logapriyan K", linkedin: "https://www.linkedin.com/in/logapriyan-k-2940b6274" },
    //     ],
    //     fourthYear: [
    //       { name: "Jawahar RL", linkedin: "https://www.linkedin.com/in/jawahar-rl-489aa426a" },
    //       { name: "Jayasri R", linkedin: "https://www.linkedin.com/in/jayasri-r-39b6b3280/" },
    //       { name: "Kavya K", linkedin: "https://www.linkedin.com/in/kavya-k-59076b320/" },
    //       { name: "Muthukrishnan M", linkedin: "https://www.linkedin.com/in/muthukrishnan25" },
    //       { name: "Vijay Muruga A", linkedin: "https://www.linkedin.com/in/vijaymuruga-a-vj02/" },
    //     ],
    //   },
    // },
];

const it_hod = {
    name: "Dr.C.Uma Rani",
    designation: "Head of the Department, it",
    pic: uma_rani_sq,
    content:
        `The Department of Computer Science and Engineering welcomes you to be a part of the thriving computer science community and to become visionaries and change makers of the future.
    Computing has become inseparable from human life. It has found a prominent place in our day-to-day life, and we are constantly striving to cope with it.
    Computer Science serves as the foundation for various technological advancements that the world sees today.
    The field has grown by leaps and bounds, and the future innovations it brings never seem to slow down.
    The Department of Computer Science and Engineering was established in the year 2001.
    The department is equipped with well-qualified and experienced faculty members. The department has good laboratory facilities. Students are regularly monitored and mentored by an experienced team of faculty advisors. 
    Students are motivated to work on industry and academia research problems and are guided by faculty members. They are exposed to various opportunities such as in-plant training, internships, and workshops during their course of study.
    A national-level technical symposium is conducted by the department.
    This improves many qualities of our students in excelling in their profession, such as updating, upskilling, reskilling, teamwork, and leadership skills with time-bound targets. Some of our alumni have grown to great heights and constantly interact with the department. 
    They also guide our students in various academic, placement, and extracurricular activities`,
};

const it_fac_profiles = [
    {
        id: "1",
        cover: cover,
        dp: uma_rani,
        name: "Dr.C.UmaRani",
        Designation: "Associate professor & Head",
        mailid: "drcumakkd@gmail.com",
        pdf: "https://drive.google.com/file/d/1rmAwrw8Wl5g43x93TvtOK3Yl952hEDnt/view?usp=drive_link",
    },
    {
        id: "2",
        cover: cover,
        dp: chandraprabha,
        name: "K.Chandraprabha",
        Designation: "Associate professor",
        mailid: "kcprabha@gmail.com",
        pdf: "https://drive.google.com/file/d/1vLl4q7g8vqOGGjfTlJQvFL1tkmoLVfVM/view?usp=drive_link",
    },
    {
        id: "3",
        cover: cover,
        dp: suhaila,
        name: "S.Syed Suhaila",
        Designation: "Assistant professor",
        mailid: "syedsuhaila63@gmail.com",
        pdf: "https://drive.google.com/file/d/1bhp8EW2O_4bXHvchHsbfsE-ylujZnDfe/view?usp=drive_link",
    },
    {
        id: "4",
        cover: cover,
        dp: sk,
        name: "Dr.K.Sundara Krishnan",
        Designation: "Assistant professor",
        mailid: "sundarakrishnank@gmail.com",
        pdf: "https://drive.google.com/file/d/1Q8LmN5KQyHpSfPGzqJxVSleJzQg_hHPj/view?usp=drive_link",
    },
    {
        id: "5",
        cover: cover,
        dp: hema,
        name: "Dr.N.Hema Rajini",
        Designation: "Associate professor",
        mailid: "auhemasmith@yahoo.co.in",
        pdf: "https://drive.google.com/file/d/1PzD1k3JgWvEyM75nEx0CBqzEqH2FVBpz/view?usp=drive_link",
    },
    {
        id: "6",
        cover: cover,
        dp: anbu,
        name: "Anbu Selvi P",
        Designation: "Assistant professor",
        mailid: "anbuselvi17@gmail.com",
        pdf: "https://drive.google.com/file/d/19_plkpq1IGaxhevM7d1QUyVZocjaPcoe/view?usp=drive_link",
    },
    {
        id: "7",
        cover: cover,
        dp: karthiga,
        name: "G. Karthika",
        Designation: "Assistant professor",
        mailid: "kartiga.g@gmail.com",
        pdf: "https://drive.google.com/file/d/1SRHrupLxqjI6IzVpVVEzmAS8MpTUJp6I/view?usp=drive_link",
    },
    {
        id: "8",
        cover: cover,
        dp: rajanandhini,
        name: "Mrs.M.Rajanandhini",
        Designation: "Assistant professor(Ad-hoc)",
        mailid: "priyamnandhini@gmail.com",
        pdf: "https://drive.google.com/file/d/1ORvnOsK4rvj_e9jIt27xnoa7iEPXKn5H/view?usp=drive_link",
    },
    {
        id: "9",
        cover: cover,
        dp: ramakrishnan,
        name: "Mr.S.Ramakrishnan",
        Designation: "Assistant professor",
        mailid: "srk.accet@gmail.com",
        pdf: "https://drive.google.com/file/d/12wPIyujrnvmyzbue7CyL0q4NPxVQG9l_/view?usp=sharing",
    },
    {
        id: "10",
        cover: cover,
        dp: kalaiselvi,
        name: "Mrs.M.Kalaiselvi",
        Designation: "Assistant professor",
        mailid: "kalailaya@gmail.com",
        pdf: "https://drive.google.com/file/d/151ARd_n_lykJj81budIlBrFnvFv6e1P6/view?usp=sharing",
    },
];
const it_sup_profiles = [
    {
        id: "1",
        cover: cover,
        dp: vijay,
        name: "G.Vijaya venkata krishnan",
        Designation: "Foreman Instructor",
        mailid: "vijayvisanth@gmail.com",
        pdf: "https://drive.google.com/file/d/1Ly5l7Ssz33FAxhL9KrL_x8-ypfV-tB7U/view?usp=drive_link",
    },
    {
        id: "2",
        cover: cover,
        dp: akbar,
        name: "J.Akbar Ali",
        Designation: "Electrician - II",
        mailid: "akku1485@gmail.com",
        pdf: "https://drive.google.com/file/d/1OllkiXemM6CLJVki16l-Ruccr7H2l2cn/view?usp=drivesdk"
    },
    {
        id: "3",
        cover: cover,
        dp: suryamam,
        name: "S.Suriya",
        Designation: "Lab Assistant",
        mailid: "rithikadharshan2016@gmail.com",
        pdf: "https://drive.google.com/file/d/1arAIkbNCVvxBsTjt_dzk5rRw-gEWMAWu/view?usp=drive_link",
    },

    {
        id: "4",
        cover: cover,
        dp: rajendran,
        name: "S.Rajendran",
        Designation: "Mechanic Grade-II",
        mailid: "bhuvanagirirajendran@gmail.com",
        pdf: "https://drive.google.com/file/d/160eR2fkBXQKrWneCnac3Tjfz0nnnS34i/view?usp=drive_link",
    },
    {
        id: "5",
        cover: cover,
        dp: vinayagamoorthy,
        name: "K.Vinayagamoorthy",
        Designation: "Unskilled Assistant",
        mailid: "vinayagamoorthivinayagam05@gmail.com",
        pdf: "https://drive.google.com/file/d/1M-LfHhx_PIdBOzvKSTaJAjF_o147pfvn/view?usp=drive_link",


    }
    // {
    //   id: "5",
    //   cover: cover,
    //   dp: raja,
    //   name: "R.Raja",
    //   Designation: "Cleaner",
    //   // mailid: "",
    //   pdf: "https://drive.google.com/file/d/1wUX-bfiQt9R4we_JICXi9LebyhG-7cBQ/view?usp=drive_link",
    // },
];
const it_vision = {
    id: "1",
    visiondata:
        `To emerge as a globally recognized center of excellence in Information Technology 
education, research, and innovation by developing competent professionals with ethical values, 
leadership qualities, and a commitment to sustainable societal and industrial growth. `,
};
const it_mission = [
    {
        id: "1",
        mission:
            `To provide quality education in Information Technology through a dynamic curriculum, 
advanced pedagogy, and industry collaboration to meet global standards and societal needs. To foster research, innovation, and entrepreneurship in emerging areas of IT to develop 
sustainable and technology-driven solutions for real-world challenges.To nurture ethical values, leadership, and lifelong learning among students to enable them to 
contribute responsibly to the profession and society. To establish strong academia–industry partnerships that promote experiential learning, skill 
enhancement, and employability in a rapidly evolving technological landscape`,
    },
];

const it_peo = [
    {
        id: "1",
        head: "PEO 1",
        house: "left",
        content:
            "Professional Competence: Graduates will apply fundamental knowledge of mathematics, science, and information technology to analyze, design, and develop efficient software and hardware solutions for real-world problems.",
    },
    {
        id: "2",
        head: "PEO 2",
        house: "right",
        content:
            "Adaptability in Research, Innovation and Lifelong Learning: Graduates will adapt to emerging technologies, tools, and frameworks, and will engage in continuous learning, research, and professional development to stay relevant in the dynamic IT industry.",
    },
    {
        id: "3",
        head: "PEO 3",
        house: "left",
        content:
            "Ethical and Social Responsibility: Graduates will demonstrate ethical behavior, professional integrity, and social responsibility, contributing to sustainable and inclusive technological development.",
    },
    {
        id: "4",
        head: "PEO 4",
        house: "right",
        content:
            "Leadership and Teamwork: Graduates will have assumed leadership roles or made significant contributions in multidisciplinary teams, startups, or organizations, showcasing effective communication and teamwork in delivering impactful IT solutions.",
    },
];

const it_outcomes = [
    {
        id: "1",
        point:
            "Engineering knowledge: Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.",
    },
    {
        id: "2",
        point:
            "Problem analysis: Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using first principles of mathematics, natural sciences, and engineering sciences.",
    },
    {
        id: "3",
        point:
            "Design/development of solutions: Design solutions for complex engineering problems and design system components or processes that meet the specified needs with appropriate consideration for the public health and safety, and the cultural, societal, and environmental considerations.",
    },
    {
        id: "4",
        point:
            "Conduct investigations of complex problems: Use research-based knowledge and research methods including design of experiments, analysis and interpretation of data, and synthesis of the information to provide valid conclusions.",
    },
    {
        id: "5",
        point:
            "Modern tool usage: Create, select, and apply appropriate techniques, resources, and modern engineering and IT tools including prediction and modeling to complex engineering activities with an understanding of the limitations.",
    },
    {
        id: "6",
        point:
            "The engineer and society: Apply reasoning informed by the contextual knowledge to assess societal, health, safety, legal and cultural issues and the consequent responsibilities relevant to the professional engineering practice.",
    },
    {
        id: "7",
        point:
            "Environment and sustainability: Understand the impact of the professional engineering solutions in societal and environmental contexts, and demonstrate the knowledge of, and need for sustainable development.",
    },
    {
        id: "8",
        point:
            "Ethics: Apply ethical principles and commit to professional ethics and responsibilities and norms of the engineering practice.",
    },
    {
        id: "9",
        point:
            "Individual and team work: Function effectively as an individual, and as a member or leader in diverse teams, and in multidisciplinary settings.",
    },
    {
        id: "10",
        point:
            "Communication: Communicate effectively on complex engineering activities with the engineering community and with society at large, such as, being able to comprehend and write effective reports and design documentation, make effective presentations, and give and receive clear instructions.",
    },
    {
        id: "11",
        point:
            "Project management and finance: Demonstrate knowledge and understanding of the engineering and management principles and apply these to one's own work, as a member and leader in a team, to manage projects and in multidisciplinary environments.",
    },
    {
        id: "12",
        point:
            "Life-long learning: Recognize the need for, and have the preparation and ability to engage in independent and life-long learning in the broadest context of technological change.",
    },
];

const it_spec_outcomes = [
    {
        id: "1",
        point:
            `Computing and Application Development: Apply core concepts of computing, programming, data structures, and algorithms to design, develop, and deploy efficient software and IT-based systems for real-world applications.`,
    },
    {
        id: "2",    
        point:
            `Emerging Technologies and Research: Utilize modern tools and technologies such as Artificial Intelligence, Data Analytics, Cloud Computing, and Cybersecurity to innovate and conduct research addressing industrial and societal challenges.`,
    },
    {
        id: "3",
        point:
            `Professional Practice and Sustainable Solutions: Demonstrate professional competence, ethical responsibility, and sustainable practices in delivering IT solutions that support organizational, societal, and environmental well-being.`,
    },
];

const it_labs = [
    {
        id: "1",
        heading: "Common Computer Lab (G2)",
        "sub-head": "",
        pic: it_com_lab,
        content_1:
            "The Common Computer Lab (G2) is a spacious facility measuring 18.3 meters by 6.9 meters, equipped to accommodate up to 50 computers. Each computer is powered by an Intel Core i3 processor and is configured with 4 GB of RAM and a 1 TB hard drive. The operating system in use is Windows 7, providing a stable environment for various software applications.",
        content_2:
            "This lab is well-suited for programming and development tasks, offering essential software tools such as Python 3, Turbo C, Microsoft Visual Studio, JDK 7 for Java development, and Dev C++. With this hardware and software setup, students and researchers have the necessary resources to engage in coding, software development, and related activities effectively.",
    },
    {
        id: "2",
        heading: "Casetools Lab (G6)",
        "sub-head": "",
        pic: it_case_lab,
        content_1:
            "The CASETOOLS LAB (G6) is a well-structured space measuring 18.3 meters by 6.9 meters, thoughtfully designed to accommodate 25 computers. These computers are equipped with varying hardware specifications, featuring Intel Core i3 processors, with a range of 2 GB and 4 GB of RAM, and hard drives of both 1 TB and 500 GB capacities.",
        content_2:
            "Running on the Windows 7 operating system, this lab provides a reliable platform for various software applications. Specifically tailored to support computer-aided software engineering, the lab offers essential tools such as Turbo C, Microsoft Visual Studio, and Rational Rose. This setup empowers students and professionals to engage in software development, modeling, and related activities efficiently and effectively.",
    },
    {
        id: "3",
        heading: "Graphics and Multimedia Lab (F2)",
        "sub-head": "",
        pic: it_grap_lab,
        content_1:
            "The Graphics and Multimedia Lab (F2) is a spacious facility spanning 18.3 meters by 6.9 meters, thoughtfully designed to accommodate 55 computers. These computers boast a variety of hardware specifications, featuring Intel Core i3 and i5 processors, each equipped with 4 GB of RAM and hard drives of 1 TB and 500 GB capacities. ",
        content_2:
            "Operating systems include both Windows 7 and Windows 8, providing versatility for software applications. This lab is equipped with a range of software tools, including C#, Visual Studio, Oracle 10g, NetBeans, Turbo C, and Multimedia Flash 8. With this impressive hardware and software setup, students and professionals have the ideal environment for graphic design, multimedia development, and related creative endeavors.",
    },
    {
        id: "4",
        heading: "DBMS Lab (F4)",
        "sub-head": "",
        pic: it_dbms_lab,
        content_1:
            "The DBMS Lab (F4) is a spacious facility, measuring 22 meters by 6.9 meters, dedicated to database management systems. It houses 52 computers equipped with a range of hardware specifications, featuring Intel Core i7 and i3 processors, with 2 GB and 4 GB of RAM options, and hard drives of 1 TB and 500 GB capacities. ",
        content_2:
            "The lab offers a versatile environment with multiple operating systems, including Windows 8, Windows 7, and Ubuntu, catering to a variety of software applications. Students and researchers in this lab have access to essential software tools such as Oracle 10g for database management, Rational Rose for software modeling, JDK 7 for Java development, Visual Studio, and Turbo C++ for programming needs. This comprehensive setup empowers users to excel in database-related tasks and software development.",
    },
    {
        id: "5",
        heading: "Microprocessor and Digital Lab (F6)",
        "sub-head": "",
        pic: it_mpmc_lab,
        content_1:
            "The Microprocessor & Digital Lab (F6) is a dedicated facility spanning 18.3 meters by 6.9 meters, designed for hands-on exploration of microprocessor and digital electronics concepts. This lab is well-equipped with a specialized set of hardware, including 8085 Trainer Kits, 8086 Trainer Kits, 8051 Trainer Kit, and IC Trainer Kit. ",
        content_2:
            "These resources provide students and researchers with the invaluable opportunity to gain practical experience in working with microprocessors and digital circuits. Whether it's programming and interfacing microcontrollers or delving into the intricate world of digital electronics, this lab serves as a vital hub for fostering a deep understanding of these fundamental principles within the realm of computer science and engineering.",
    },
];

// const it_dept_events=[
//   {
//       'id':'1',
//       'heading':"One Week Training on Robotics",
//       'sub-head':'Some representative placeholder content for the second slide of the carousel.',
//       'pic':robotics,
//       'content_1':'Our Commitment as a Centre of Engineering Education is to impart Technical Knowledge par excellence, motivate the learners in Research, evolve result-oriented, innovative techniques in Engineering, provide necessary career guidance, and train our learners'+
//                   'in leadership qualities so as to achieve better productivity and prosperity for our country.',
//       'content_2':"ACGCET, a leader in higher education in engineering and technology, is committed to excellence through the delivery of outstanding undergraduate and graduate education that remains current and responsive to the diverse needs of those it serves. The institution’s"+
//       "faculty and staff promote the intellectual, professional, social, and personal development of its students through innovations in learning, scholarship, and creative endeavours. Students, faculty, and staff partner to create strong"+
//       "engagement with the local, national, and global communities. The institution dedicates itself to academic vitality, integrity, and diversity."
//   },
//   {
//       'id':'2',
//       'heading':'Placement Activities',
//       'sub-head':'Some representative placeholder content for the second slide of the carousel.',
//       'pic':placement,
//       'content_1':'Our Commitment as a Centre of Engineering Education is to impart Technical Knowledge par excellence, motivate the learners in Research, evolve result-oriented, innovative techniques in Engineering, provide necessary career guidance, and train our learners'+
//                   'in leadership qualities so as to achieve better productivity and prosperity for our country.',
//       'content_2':"ACGCET, a leader in higher education in engineering and technology, is committed to excellence through the delivery of outstanding undergraduate and graduate education that remains current and responsive to the diverse needs of those it serves. The institution’s"+
//       "faculty and staff promote the intellectual, professional, social, and personal development of its students through innovations in learning, scholarship, and creative endeavours. Students, faculty, and staff partner to create strong"+
//       "engagement with the local, national, and global communities. The institution dedicates itself to academic vitality, integrity, and diversity."
//   },
//
// ]

const it_stud_data = [
    {
        id: "1",
        heading: "2nd Year",
        component: "table",
        structure: {
            data: [
                { sno: "1", regno: "91762415001", name: "ABISHEK G" },
                { sno: "2", regno: "91762415002", name: "ABILASH L" },
                { sno: "3", regno: "91762415003", name: "AJITH S" },
                { sno: "4", regno: "91762415004", name: "AMIRTHA M" },
                { sno: "5", regno: "91762415005", name: "ANTONY JOSHWA F" },
                { sno: "6", regno: "91762415006", name: "ASHIKA R" },
                { sno: "7", regno: "91762415007", name: "BALA ADHITHYA B" },
                { sno: "8", regno: "91762415008", name: "BHUVANESHWARI B" },
                { sno: "9", regno: "91762415009", name: "CHARULATHA R" },
                { sno: "10", regno: "91762415010", name: "DHIVYADHARSHINI R" },
                { sno: "11", regno: "91762415011", name: "DRAVID R" },
                { sno: "12", regno: "91762415012", name: "GAYATHRI G" },
                { sno: "13", regno: "91762415013", name: "GOKILA M" },
                { sno: "14", regno: "91762415014", name: "GOPIKA G" },
                { sno: "15", regno: "91762415015", name: "GOPIKA K" },
                { sno: "16", regno: "91762415016", name: "GUHAN V" },
                { sno: "17", regno: "91762415017", name: "HARSHINI S" },
                { sno: "18", regno: "91762415018", name: "JUWAIRIYAH M" },
                { sno: "19", regno: "91762415019", name: "KAMALESH T" },
                { sno: "20", regno: "91762415020", name: "KANAGALAKSHMI K" },
                { sno: "21", regno: "91762415021", name: "KAVIYA M" },
                { sno: "22", regno: "91762415022", name: "KISHOR M" },
                { sno: "23", regno: "91762415023", name: "LAJITHA S" },
                { sno: "24", regno: "91762415024", name: "LATHIKA  A" },
                { sno: "25", regno: "91762415025", name: "LAWRANCE A" },
                { sno: "26", regno: "91762415026", name: "MAGATHI   M" },
                { sno: "27", regno: "91762415027", name: "MAGESHWARI B" },
                { sno: "28", regno: "91762415028", name: "MAHA LAKSHMI S" },
                { sno: "29", regno: "91762415029", name: "MANGALAKSHMI V" },
                { sno: "30", regno: "91762415030", name: "MERLIN SOFIA J" },
                { sno: "31", regno: "91762415031", name: "NABEESA A" },
                { sno: "32", regno: "91762415032", name: "NACHIYAPPAN K" },
                { sno: "33", regno: "91762415033", name: "NAVYA J M" },
                { sno: "34", regno: "91762415034", name: "NAVYA SRI R" },
                { sno: "35", regno: "91762415035", name: "NISHANTHINI R" },
                { sno: "36", regno: "91762415036", name: "NITHISH M" },
                { sno: "37", regno: "91762415037", name: "NITHIYADEVI M" },
                { sno: "38", regno: "91762415038", name: "OVIYASRI S" },
                { sno: "39", regno: "91762415039", name: "PALANIAPPAN V" },
                { sno: "40", regno: "91762415040", name: "PURUSHOTHAMAN. R" },
                { sno: "41", regno: "91762415042", name: "RAGUL R" },
                { sno: "42", regno: "91762415043", name: "RAMYA  S" },
                { sno: "43", regno: "91762415044", name: "RISHMA R M" },
                { sno: "44", regno: "91762415045", name: "RUBESH S" },
                { sno: "45", regno: "91762415046", name: "SANTHIYA R" },
                { sno: "46", regno: "91762415047", name: "SANTHYA LAKSHMI V" },
                { sno: "47", regno: "91762415048", name: "SARAVANAN E" },
                { sno: "48", regno: "91762415049", name: "SRIGANESH B" },
                { sno: "49", regno: "91762415050", name: "SRIMATHI G" },
                { sno: "50", regno: "91762415051", name: "SUBAHARINI S" },
                { sno: "51", regno: "91762415052", name: "SUBASH K" },
                { sno: "52", regno: "91762415053", name: "SWETHA V" },
                { sno: "53", regno: "91762415054", name: "THIAGARAJAN K" },
                { sno: "54", regno: "91762415055", name: "VARSHA S" },
                { sno: "55", regno: "91762415056", name: "VISHWA S" },
                { sno: "56", regno: "91762415057", name: "VISWAKPRANAV M" },
                { sno: "57", regno: "91762415058", name: "SAHANA R" },
            ],

            columns: [
                { field: "sno", header: "sno" },
                { field: "regno", header: "Register No" },
                { field: "name", header: "name" },
            ],
        },
    },
    {
        id: "2",
        heading: "3rd Year",
        component: "table",
        structure: {
            data: [
                {
                    sno: "1",
                    regno: "91762315001",
                    name: "AJISHA N S",
                },
                {
                    sno: "2",
                    regno: "91762315002",
                    name: "ALAGESHWARI M",
                },
                {
                    sno: "3",
                    regno: "91762315003",
                    name: "ALAKESHVARKUMAR R",
                },
                {
                    sno: "4",
                    regno: "91762315004",
                    name: "AMRESH C",
                },
                {
                    sno: "5",
                    regno: "91762315005",
                    name: "AMUTHA R",
                },
                {
                    sno: "6",
                    regno: "91762315006",
                    name: "ASHWINI D",
                },
                {
                    sno: "7",
                    regno: "91762315007",
                    name: "ASWITHA A V",
                },
                {
                    sno: "8",
                    regno: "91762315008",
                    name: "AUSTIN TINO M L",
                },
                {
                    sno: "9",
                    regno: "91762315009",
                    name: "AYYANAR G",
                },
                {
                    sno: "10",
                    regno: "91762315010",
                    name: "BALAJI S",
                },
                {
                    sno: "11",
                    regno: "91762315011",
                    name: "BHAVANI SANKARI P",
                },
                {
                    sno: "12",
                    regno: "91762315012",
                    name: "DEEPAK M",
                },
                {
                    sno: "13",
                    regno: "91762315013",
                    name: "DHANUSH KUMAR M",
                },
                {
                    sno: "14",
                    regno: "91762315014",
                    name: "DHAVASEELAN C",
                },
                {
                    sno: "15",
                    regno: "91762315015",
                    name: "GOKUL A",
                },
                {
                    sno: "16",
                    regno: "91762315016",
                    name: "GOWTHAM V",
                },
                {
                    sno: "17",
                    regno: "91762315017",
                    name: "GURUMUGESH S",
                },
                {
                    sno: "18",
                    regno: "91762315018",
                    name: "HASAN HASIM V M",
                },
                {
                    sno: "19",
                    regno: "91762315020",
                    name: "ISWARYALAKSHMI J",
                },
                {
                    sno: "20",
                    regno: "91762315021",
                    name: "JASMINE GLORY S",
                },
                {
                    sno: "21",
                    regno: "91762315022",
                    name: "KALAIVANI T",
                },
                {
                    sno: "22",
                    regno: "91762315023",
                    name: "KAMALNATH A",
                },
                {
                    sno: "23",
                    regno: "91762315024",
                    name: "KAMESHWARAN V",
                },
                {
                    sno: "24",
                    regno: "91762315025",
                    name: "KARTHIK RAJA J",
                },
                {
                    sno: "25",
                    regno: "91762315026",
                    name: "KAVICHEZHIAN T",
                },
                {
                    sno: "26",
                    regno: "91762315027",
                    name: "KAVIYA DHARSHINI P",
                },
                {
                    sno: "27",
                    regno: "91762315028",
                    name: "KEVIN S V",
                },
                {
                    sno: "28",
                    regno: "91762315029",
                    name: "LAVANYA A",
                },
                {
                    sno: "29",
                    regno: "91762315030",
                    name: "MADASAMY I",
                },
                {
                    sno: "30",
                    regno: "91762315031",
                    name: "MAHIRA V M",
                },
                {
                    sno: "31",
                    regno: "91762315032",
                    name: "MANJULA V",
                },
                {
                    sno: "32",
                    regno: "91762315033",
                    name: "MANOJKUMAR R",
                },
                {
                    sno: "33",
                    regno: "91762315034",
                    name: "MIDHULA R",
                },
                {
                    sno: "34",
                    regno: "91762315035",
                    name: "MURALIDHARAN S",
                },
                {
                    sno: "35",
                    regno: "91762315036",
                    name: "NAGOOR NASURUDEEN O M",
                },
                {
                    sno: "36",
                    regno: "91762315037",
                    name: "NITHYA PURNIMA B",
                },
                {
                    sno: "37",
                    regno: "91762315038",
                    name: "NIVEDHA B",
                },
                {
                    sno: "38",
                    regno: "91762315039",
                    name: "PAVITHA M",
                },
                {
                    sno: "39",
                    regno: "91762315040",
                    name: "RANJITH D",
                },
                {
                    sno: "40",
                    regno: "91762315041",
                    name: "ROHIT NAREN K",
                },
                {
                    sno: "41",
                    regno: "91762315043",
                    name: "SATHISH S",
                },
                {
                    sno: "42",
                    regno: "91762315044",
                    name: "SIVABRINDHA P",
                },
                {
                    sno: "43",
                    regno: "91762315045",
                    name: "SRIKRISHNA M",
                },
                {
                    sno: "44",
                    regno: "91762315046",
                    name: "SUJI P",
                },
                {
                    sno: "45",
                    regno: "91762315047",
                    name: "SUMITHRA P",
                },
                {
                    sno: "46",
                    regno: "91762315048",
                    name: "THAMARAI NAGASAMY K",
                },
                {
                    sno: "47",
                    regno: "91762315049",
                    name: "VIGNESH M",
                },
                {
                    sno: "48",
                    regno: "91762315050",
                    name: "VIJAYADHARSAN S",
                },
                {
                    sno: "49",
                    regno: "91762315052",
                    name: "VIJAYALAKSHMI N",
                },

                {
                    sno: "50",
                    regno: "91762315053",
                    name: "VISALI E",
                },
                {
                    sno: "51",
                    regno: "91762315054",
                    name: "VISHWA M",
                },
                {
                    sno: "52",
                    regno: "91762315055",
                    name: "YOGAESH V E",
                },
                {
                    sno: "53",
                    regno: "91762315056",
                    name: "YOGESWARAN C",
                },
                {
                    sno: "54",
                    regno: "91762315057",
                    name: "GNANAVALLI L",
                },
                {
                    sno: "55",
                    regno: "91762315058",
                    name: "SANJEEV KUMARAN S",
                },
                {
                    sno: "56",
                    regno: "91762415201",
                    name: "KEERTHANA S",
                },
                {
                    sno: "57",
                    regno: "91762415202",
                    name: "NARMATHA R",
                },
                {
                    sno: "58",
                    regno: "91762415203",
                    name: "NIKCHETHA R",
                },
                {
                    sno: "59",
                    regno: "91762415204",
                    name: "PRIYADHARSHINI R",
                },
                {
                    sno: "60",
                    regno: "91762415205",
                    name: "SINGUPANDI C",
                },
                {
                    sno: "61",
                    regno: "91762415206",
                    name: "SRIPRIYAN S",
                },
                {
                    sno: "62",
                    regno: "91762415207",
                    name: "VINOTHA B",
                },
                {
                    sno: "63",
                    regno: "91762415301",
                    name: "MOHAN R",
                },
                {
                    sno: "64",
                    regno: "91762415302",
                    name: "VISHNU R",
                },
                {
                    sno: "65",
                    regno: "91762415501",
                    name: "KOKILA SRI P",
                },
            ],
            columns: [
                { field: "sno", header: "sno" },
                { field: "regno", header: "Register No" },
                { field: "name", header: "name" },
            ],
        },
    },

    {
        id: "3",
        heading: "4th Year",
        component: "table",
        structure: {
            data: [
                {
                    sno: "1",
                    regno: "91762215001",
                    name: "ABINAYA M",
                },
                {
                    sno: "2",
                    regno: "91762215002",
                    name: "ABINAYA SRI G",
                },
                {
                    sno: "3",
                    regno: "91762215003",
                    name: "ABINESH S A",
                },
                {
                    sno: "4",
                    regno: "91762215005",
                    name: "AMUDHAN M",
                },
                {
                    sno: "5",
                    regno: "91762215006",
                    name: "ANITHA K",
                },
                {
                    sno: "6",
                    regno: "91762215007",
                    name: "ATCHAYA M",
                },
                {
                    sno: "7",
                    regno: "91762215008",
                    name: "CHINNARANI F",
                },
                {
                    sno: "8",
                    regno: "91762215009",
                    name: "CHUBATHRAN K",
                },
                {
                    sno: "9",
                    regno: "91762215010",
                    name: "DEEPA M",
                },
                {
                    sno: "10",
                    regno: "91762215011",
                    name: "DHANUSH A",
                },
                {
                    sno: "11",
                    regno: "91762215012",
                    name: "DIVYABHARATHI S",
                },
                {
                    sno: "12",
                    regno: "91762215013",
                    name: "DURAIPANDI J",
                },
                {
                    sno: "13",
                    regno: "91762215014",
                    name: "ELAKKIYA A N",
                },
                {
                    sno: "14",
                    regno: "91762215015",
                    name: "ELAVARASAN A",
                },
                {
                    sno: "15",
                    regno: "91762215017",
                    name: "GANIKA SRI T",
                },
                {
                    sno: "16",
                    regno: "91762215018",
                    name: "GOPINATH S",
                },
                {
                    sno: "17",
                    regno: "91762215019",
                    name: "GURU SRINIVASAN P",
                },
                {
                    sno: "18",
                    regno: "91762215021",
                    name: "IYYAPPAN A",
                },
                {
                    sno: "19",
                    regno: "91762215023",
                    name: "KAMALA KANNAN M",
                },
                {
                    sno: "20",
                    regno: "91762215024",
                    name: "KANISHKA M",
                },
                {
                    sno: "21",
                    regno: "91762215025",
                    name: "KARISHMA C",
                },
                {
                    sno: "22",
                    regno: "91762215026",
                    name: "KAVITHA K",
                },
                {
                    sno: "23",
                    regno: "91762215027",
                    name: "KESAVA PRIYA G",
                },
                {
                    sno: "24",
                    regno: "91762215028",
                    name: "LOGAPRIYAN K",
                },
                {
                    sno: "25",
                    regno: "91762215029",
                    name: "MAHIMA S",
                },
                {
                    sno: "26",
                    regno: "91762215031",
                    name: "MOHANA MALA J",
                },
                {
                    sno: "27",
                    regno: "91762215032",
                    name: "MONISHWARAN S",
                },
                {
                    sno: "28",
                    regno: "91762215033",
                    name: "MUGESWARAN K",
                },
                {
                    sno: "29",
                    regno: "91762215034",
                    name: "NASHRIN FATHIMA K",
                },
                {
                    sno: "30",
                    regno: "91762215035",
                    name: "NISHANTHI S",
                },
                {
                    sno: "31",
                    regno: "91762215036",
                    name: "POOJA R",
                },
                {
                    sno: "32",
                    regno: "91762215037",
                    name: "POORNISHA S",
                },
                {
                    sno: "33",
                    regno: "91762215038",
                    name: "PRITHIVI P",
                },
                {
                    sno: "34",
                    regno: "91762215040",
                    name: "PURUSOTHAMAN T",
                },
                {
                    sno: "35",
                    regno: "91762215041",
                    name: "RISIKA K",
                },
                {
                    sno: "36",
                    regno: "91762215042",
                    name: "RUKSHANA FATHIMA U",
                },
                {
                    sno: "37",
                    regno: "91762215043",
                    name: "SAKTHIVEL A",
                },
                {
                    sno: "38",
                    regno: "91762215044",
                    name: "SAKTHIVEL P",
                },
                {
                    sno: "39",
                    regno: "91762215045",
                    name: "SANTHIYA M",
                },
                {
                    sno: "40",
                    regno: "91762215047",
                    name: "SHABANA PARVEEN S",
                },
                {
                    sno: "41",
                    regno: "91762215048",
                    name: "SIVARAMAN P",
                },
                {
                    sno: "42",
                    regno: "91762215049",
                    name: "SOUNDHARKABILAN G K",
                },
                {
                    sno: "43",
                    regno: "91762215050",
                    name: "SRIRAM K",
                },
                {
                    sno: "44",
                    regno: "91762215051",
                    name: "SUDHARSAN E",
                },
                {
                    sno: "45",
                    regno: "91762215052",
                    name: "THAIYEBA TASLEEMA S",
                },
                {
                    sno: "46",
                    regno: "91762215053",
                    name: "THANGADURAI S",
                },
                {
                    sno: "47",
                    regno: "91762215054",
                    name: "VAISHALI S",
                },
                {
                    sno: "48",
                    regno: "91762215055",
                    name: "VARSHINI R",
                },
                {
                    sno: "49",
                    regno: "91762215057",
                    name: "VIMALRAJ V",
                },
                {
                    sno: "50",
                    regno: "91762215058",
                    name: "YOGA SATHYA R",
                },

                {
                    sno: "51",
                    regno: "91762315202",
                    name: "KAVIYA S",
                },
                {
                    sno: "52",
                    regno: "91762315203",
                    name: "MOHAMMED SHAJITH M I",
                },
                {
                    sno: "53",
                    regno: "91762315204",
                    name: "NANDHAKUMAR N",
                },
                {
                    sno: "54",
                    regno: "91762315205",
                    name: "SUBIKSHA M V",
                },
                {
                    sno: "55",
                    regno: "91762215301",
                    name: "INDIRA R",
                },
                {
                    sno: "56",
                    regno: "91762215302",
                    name: "MANIRAJ S",
                },
                {
                    sno: "57",
                    regno: "91762215303",
                    name: "RITHIKA S",
                },
                {
                    sno: "58",
                    regno: "91762215304",
                    name: "SANJAYKUMAR A",
                },
                {
                    sno: "59",
                    regno: "91762215305",
                    name: "VIGNESH A",
                },
                {
                    sno: "60",
                    regno: "91762215306",
                    name: "VIMALRAJAN S",
                },
                {
                    sno: "61",
                    regno: "91762115304",
                    name: "KEERTHANA S",
                },
            ],
            columns: [
                { field: "sno", header: "sno" },
                { field: "regno", header: "Register No" },
                { field: "name", header: "name" },
            ],
        },
    },
];

const it_prog_time = [
    {
        id: 27,
        head: "",
        house: "right",
        content:
            'On June 12, 2021, a webinar titled "Let\'s Solve Simple ML Problems" was held, featuring Mr. Guruprasad, a Data Scientist at ZOHO Corp, as the speaker addressing UG students.The event was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 1,
        head: "",
        house: "left",
        content:
            'On June 12, 2021, a webinar titled "Roles and Responsibilities Involved in the Life Cycle of a Product" was conducted, with Mr. Prakash, a Member of Leadership Staff at ZOHO Corp, as the speaker addressing UG students. The event was coordinated by Prof. K. Chandraprabha,  HOD of it',
    },
    {
        id: 2,
        head: "",
        house: "right",
        content:
            'On June 11, 2021, a webinar titled "How to Start Your Career as an Ultimate UI/UX Designer" was held, featuring Mr.Prakash Kumar, a Visual Designer at ZOHO Corp, as the speaker, addressing UG students. The event was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 3,
        head: "",
        house: "left",
        content:
            'On June 10, 2021, a webinar titled "Android Platform" was conducted with Mr.Sathish Kumar, an Android Developer at Mind Tree Ltd., as the speaker addressing UG students. The event was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 4,
        head: "",
        house: "right",
        content:
            'On June 9, 2021, a webinar titled "Introduction to Apache Kafka" was conducted with Ms. Swetha M, a Graduate Engineer Trainee at Data Aces, as the speaker addressing UG students. The event was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 5,
        head: "",
        house: "left",
        content:
            'On June 8,2021, a webinar titled "Looking for a Lucrative Career? Gate Preparation Strategy and Opportunities After Gate" featured Ms.Smriti S, a Gate Aspirant and Trainer, as the speaker addressing UG students. The event was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 6,
        head: "",
        house: "right",
        content:
            'On June 7, 2021, a webinar titled "Introduction to UI/UX Design" was conducted, with Mr.Amsavarathan K, a Product Designer at Kissflow, as the speaker addressing UG students. The event was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 7,
        head: "",
        house: "left",
        content:
            'On June 5, 2021, a webinar on "Data Visualization Using Tableau" was held, featuring Ms. Keerthana Sankari S as the speaker addressing UG students. The event was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 8,
        head: "",
        house: "right",
        content:
            'On June 3, 2021, a webinar titled "Building Self-Confidence" was conducted with Mr.Vignesh T, a Software Engineer at Admindroid, as the speaker, addressing UG students. The event was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 9,
        head: "",
        house: "left",
        content:
            'On June 2, 2021, a webinar titled "Blockchain Technology and Usage of Algorithms in the Real World" featured Mr.Nithish Kumar P, a Software Developer at Admindroid, as the speaker, addressing UG students. The event was coordinated by Prof.K.Chandraprabha, HOD of it.',
    },
    {
        id: 10,
        head: "",
        house: "right",
        content:
            'On June 1, 2021, a webinar titled "Etiquette for Future Engineers - Need of the Hour" was conducted with Dr. Hyacinth Suganthi X, the Placement Officer at ACGCET, as the speaker, addressing UG students. The event was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 11,
        head: "",
        house: "left",
        content:
            'On May 31, 2021, a webinar titled "Fundamentals of Web Development" featured Kishor Kumar G, a Software Engineer at MulticoreWare, as the speaker, addressing UG students. The event was coordinated by Prof. K. Chandraprabha, HOD of it.',
    },
    {
        id: 12,
        head: "",
        house: "right",
        content:
            'On May 29,2021, a webinar titled "Fundamentals of Data Science" was conducted with Sasikumar Gp, a Senior Analyst from LatentView Analysis, as the resource person, addressing UG students. The event was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 13,
        head: "",
        house: "left",
        content:
            'On May 28,2021, a webinar titled "Data-Driven Technologies and Skills Needed" featured Bagavathy Priya N, a Data Analyst from Shopup, as the speaker, addressing UG students. The event was coordinated by Prof.K.Chandraprabha,  HOD of it',
    },
    {
        id: 14,
        head: "",
        house: "right",
        content:
            "DEFTERA-21, held on March 6, 2021, featured Dr.K.Manonmani, Principal of ACGCET, engaging with UG students, and Mr.L.Rasikannan, AP/it, as part of the event",
    },
    {
        id: 15,
        head: "",
        house: "left",
        content:
            'On May 29,2020, a webinar titled "Machine Learning Practices Followed in Industry" featured Mr. T. Radhakrishnan as the speaker, addressing UG students, and was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 16,
        head: "",
        house: "right",
        content:
            'On May 28,2020, a webinar titled "Illakiyamum Inaivazhi Vaasipum" featured Dr.Karthagaipandi, Assistant Professor at SKCE, Coimbatore, as the speaker, addressing UG students. The event was coordinated by Prof.K.Chandraprabha,  HOD of it',
    },
    {
        id: 17,
        head: "",
        house: "left",
        content:
            'On May 27, 2020, a webinar titled "AI - An Industrial Approach" featured Mr.S.Maheswaran, Project Lead at Honeywell Technology Solutions, as the speaker, addressing UG students, and it was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 18,
        head: "",
        house: "right",
        content:
            'On May 26, 2020, a webinar titled "How to Improve and Cope Up With Emerging Technologies" featured T.Krishnan Kumar, an IT Analyst at TCS, as the resource person, addressing UG students. The event was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 19,
        head: "",
        house: "left",
        content:
            'On May 25,2020, a webinar on "Introduction to DevOps" featured Mrs. Annie Michelia, a DB Specialist Architect with expertise in AWS and on-premise solutions from New Jersey, addressing UG students, and it was coordinated by Prof.K.Chandraprabha,  HOD of it.',
    },
    {
        id: 20,
        head: "",
        house: "right",
        content:
            "On February 27,2020, Cognoblaze-20 welcomed Dr.P.Tamilrasan, a scientist at CECRI, who addressed UG students in the presence of Prof.K.Chandraprabha,  HOD of it.",
    },
    {
        id: 21,
        head: "",
        house: "left",
        content:
            "DEFTERA-19, held on October 23,2019, featured Dr.R.Shanmugalakshmi, Principal of ACGCET, engaging with UG students, and Dr.C.Uma Rani,AP/it, as part of the event.",
    },
    {
        id: 22,
        head: "",
        house: "right",
        content:
            "On September 23, 2019, Cognoblaze-19 had Mr.G.Kathirvelan, Digital Transformation Lead at TCS, delivering a session to UG students, with the presence of Dr.L.Ganesan,  HOD of it.",
    },
    {
        id: 23,
        head: "",
        house: "left",
        content:
            "DEFTERA-18, held on October 16,2018, featured Dr.A.Elango, Principal of ACGCET, addressing UG students, and Dr. C. Uma Rani, AP/it, served as the coordinator for the workshop.",
    },
    {
        id: 24,
        head: "",
        house: "right",
        content:
            "A workshop on Android Application Development, held from September 14,2018, to September 15,2018, featured Mr.Sathish Kumar, a developer from Winapp IT Solutions Pvt. Ltd, as the resource person, with UG students from ACGCET and Dr. URCW as beneficiaries. Dr.L.Ganesan,  HOD of it, served as the coordinator for the workshop.",
    },
    {
        id: 25,
        head: "",
        house: "left",
        content:
            "From March 14,2018, to March 20,2018, an FDP on Computer Vision and its Application was conducted with distinguished professors from various institutes as resource persons, benefiting faculties, and coordinated by Dr.L.Ganesan, HOD of it.",
    },
    {
        id: 26,
        head: "",
        house: "right",
        content:
            "On February 15, 2018, Dr. A. Elango, the Principal of ACGCET, engaged with UG students alongside Dr. L. Ganesan, the  HOD of it, during Cognoblaze-18.",
    },
];

const it_mou_data = [
    {
        sno: "1",
        comp_name: "ABC TECHNO LABS INDIA Pvt.Ltd",
        sign_date: "12/3/2012",
        valid: "3 YEARS",
        end_date: "12/3/2015",
    },
    {
        sno: "2",
        comp_name: "ALAGAPPA UNIVERSITY,KARAIKUDI",
        sign_date: "6/14/2019",
        valid: "4 YEARS",
        end_date: "6/14/2023",
    },
    {
        sno: "3",
        comp_name: "BENCHMARK ELECTRONIC SYSTEMS PVT.LTD",
        sign_date: "7/10/2013",
        valid: "UNTIL CLOSURE OF TEQIP I",
        end_date: "-",
    },
    {
        sno: "4",
        comp_name: "BHEL,THIRUMAYAM",
        sign_date: "9/28/2015",
        valid: "-",
        end_date: "-",
    },
    {
        sno: "5",
        comp_name: "CENTRE FOR FACULTY DEVELOPMENT",
        sign_date: "11/12/2012",
        valid: "-",
        end_date: "-",
    },
    {
        sno: "6",
        comp_name: "CENTRE FOR FACULTY DEVELOPMENT,ANNA UNIVERSITY(FDTP)",
        sign_date: "6/28/2017",
        valid: "5 YEARS",
        end_date: "6/28/2022",
    },
    {
        sno: "7",
        comp_name: "Dr.UMAYAL RAMANATHAN COLLEGE FOR WOMEN,KARAIKUDI",
        sign_date: "7/21/2017",
        valid: "3 YEARS",
        end_date: "7/21/2020",
    },
    {
        sno: "8",
        comp_name: "EXCEL DIE CASTING",
        sign_date: "8/7/2017",
        valid: "3 YEARS",
        end_date: "8/7/2020",
    },
    {
        sno: "9",
        comp_name: "FORD INDIA Pvt.Ltd",
        sign_date: "11/14/2018",
        valid: "-",
        end_date: "-",
    },
    {
        sno: "10",
        comp_name: "FRONTLINE ELECTRONICS PRIVATE LTD",
        sign_date: "8/7/2017",
        valid: "3 YEARS",
        end_date: "8/7/2020",
    },
    {
        sno: "11",
        comp_name: "GREEN PLANET ENVIRONMENT SOLUTIONS",
        sign_date: "8/7/2017",
        valid: "3 YEARS",
        end_date: "8/7/2020",
    },
    {
        sno: "12",
        comp_name: "MM MICROTECH",
        sign_date: "8/7/2017",
        valid: "3 YEARS",
        end_date: "8/7/2020",
    },
    {
        sno: "13",
        comp_name: "PANTECH PROED PVT.LTD.",
        sign_date: "8/7/2017",
        valid: "3 YEARS",
        end_date: "8/7/2020",
    },
    {
        sno: "14",
        comp_name: "POLYLAB ENGINEERING EQUIPMENT",
        sign_date: "3/30/2019",
        valid: "-",
        end_date: "-",
    },
    {
        sno: "15",
        comp_name: "POWERLAB INSTRUMENTS",
        sign_date: "6/14/2019",
        valid: "-",
        end_date: "-",
    },
    {
        sno: "16",
        comp_name: "PRISMS INDIA PRIVATE LIMITED",
        sign_date: "10/10/2017",
        valid: "3 YEARS",
        end_date: "10/10/2020",
    },
    {
        sno: "17",
        comp_name: "SCIENTIFIC METAL ENGINEERS(P) LTD",
        sign_date: "12/3/2012",
        valid: "3 YEARS",
        end_date: "12/3/2015",
    },
    {
        sno: "18",
        comp_name: "SPIC TUTICORIN",
        sign_date: "3/5/2008",
        valid: "-",
        end_date: "-",
    },
    {
        sno: "19",
        comp_name: "TI CYCLES INDIA LIMITED (TICI)",
        sign_date: "-",
        valid: "-",
        end_date: "-",
    },
    {
        sno: "20",
        comp_name: "UNIVERSITY COLLEGE OF ENGINEERING&TECHNOLOGY,VBU,HZB",
        sign_date: "12/3/2012",
        valid: "2 YEARS",
        end_date: "12/3/2014",
    },
    {
        sno: "21",
        comp_name: "UNIVERSITY COLLEGE OF ENGINEERING&TECHNOLOGY,VBU,HZB",
        sign_date: "-",
        valid: "-",
        end_date: "-",
    },
    {
        sno: "22",
        comp_name: "VAIBHAVA POWER SOLUTIONS",
        sign_date: "4/11/2019",
        valid: "3 YEARS",
        end_date: "4/11/2022",
    },
    {
        sno: "23",
        comp_name: "VAIBHAVA POWER SOLUTIONS(ASHOK LEYLAND)",
        sign_date: "9/15/2014",
        valid: "2 YEARS\n(INITIALLY)",
        end_date: "9/15/2016",
    },
    {
        sno: "24",
        comp_name: "VARAGHI SOLUTION (POWEROL BY MAHINDRA)",
        sign_date: "2/23/2013",
        valid: "5 YEARS",
        end_date: "2/23/2018",
    },
    {
        sno: "25",
        comp_name: "VENUS ENERGY,BANGALORE",
        sign_date: "12/30/2015",
        valid: "3 YEARS",
        end_date: "12/30/2018",
    },
    {
        sno: "26",
        comp_name: "VENUS ENERGY,CUDDALORE",
        sign_date: "5/3/2013",
        valid: "2 YEARS",
        end_date: "5/3/2015",
    },
    {
        sno: "27",
        comp_name: "VI MICROSYSTEMS PVT.LTD.,",
        sign_date: "10/28/2013",
        valid: "2 YEARS",
        end_date: "10/28/2015",
    },
    {
        sno: "28",
        comp_name: "WABCO INDIA LIMITED",
        sign_date: "2/21/2014",
        valid: "1 YEAR",
        end_date: "2/21/2015",
    },
];

const it_asso_events = [
    {
        id: "4",
        heading: "Deftra'25",
        "sub-head": "15th APR 2025",
        pic: deftra25,
        content_1: "",
        content_2: "",
    },
    {
        id: "4",
        heading: "Code Quest",
        "sub-head": "Regular Event",
        pic: codequest,
        content_1: "",
        content_2: "",
    },
    {
        id: "3",
        heading: "Cognoblaze'24",
        "sub-head": "21th OCT 2024",
        pic: cognoblaze_24,
        content_1: "",
        content_2: "",
    },
    {
        id: "4",
        heading: "Projecthon 25",
        "sub-head": "OCT - SEPT 2025",
        pic: projecthon,
        content_1: "",
        content_2: "",
    }
    // {
    //   id: "2",
    //   heading: "Deftra'22",
    //   "sub-head":
    //     "29th NOV 2022",
    //   pic: deftra,
    //   content_1:
    //     "",
    //   content_2:
    //     "",
    // },

    // {
    //   id: "1",
    //   heading: "Cognoblaze'23",
    //   "sub-head": "26th APR 2023",
    //   pic: cogno,
    //   content_1: "",
    //   content_2: "",
    // },
    // {
    //   id: "3",
    //   heading: "Deftra'23",
    //   "sub-head":
    //     "24th NOV 2023",
    //   pic: deftra23,
    //   content_1:
    //     "",
    //   content_2:
    //     "",
    // },
];



const it_projecthon = [
    {
        id: 1,
        program: 'Project titles ',
        pdf: 'https://drive.google.com/file/d/1RHRbnSzWj03E9KEJBKpiuGcrEzDUdSfb/view?usp=drivesdk'
    },
    {
        id: 2,
        program: 'Participants ',
        pdf: 'https://drive.google.com/file/d/1R7fQc1o6AXOnv42VsXT0c-i7Ci6pVCCk/view?usp=drivesdk'
    }
]



export {
    it_dept_menu,
    it_fac_profiles,
    it_sup_profiles,
    it_mission,
    it_vision,
    it_outcomes,
    it_peo,
    it_spec_outcomes,
    it_labs,
    it_hod,
    it_stud_data,
    it_prog_time,
    it_mou_data,
    it_asso_events,
    LiveProjects,
    it_projecthon
};
